import Stack from "react-bootstrap/Stack";
import { TaskComponent } from "@/components/TaskComponent";
import Task from "@/models/Task";
import Category from "@/models/Category";
import Tag from "@/models/Tag";

export type TaskListProps = {
  tasks: Task[];
  categories: Category[];
  tags: Tag[];
  showCategoryName?: boolean;
};

export const TaskList: React.FC<TaskListProps> = ({
  tasks,
  categories,
  tags,
  showCategoryName = true,
}) => {
  const sortedTasks = [...tasks].sort(Task.compareByDueDate);

  return (
    <Stack gap={3}>
      {sortedTasks.map((task) => {
        const taskCategory =
          task.categoryId &&
          categories.find((cat) => cat.id === task.categoryId);

        const taskTags =
          task.tagsIds && task.tagsIds.length > 0
            ? task.tagsIds
                .map((tagId) => tags.find((tag) => tag.id === tagId))
                .filter((tag): tag is Tag => tag !== undefined)
            : [];

        return (
          <TaskComponent
            key={task.id}
            id={task.id}
            description={task.description}
            title={task.title}
            category={
              taskCategory && showCategoryName
                ? { name: taskCategory.getName(), id: taskCategory.id }
                : undefined
            }
            tags={taskTags.map((tag) => ({
              name: tag.getName(),
              id: tag.id,
              color: tag.getColor(),
            }))}
            dueDate={task.dueDate}
            priority={task.priority}
          />
        );
      })}
    </Stack>
  );
};
